export class ComplaintDetailsById {
    ID: number;
    languageId: number;    
    contentType: string;    
}